import React from "react";
import Page from "components/Page";
import { Props } from "./SiteCustomFields";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const SiteCustomFields = lazyWithRetry(() => import("./SiteCustomFields"));

export default (props: Props) => (
  <Page>
    <SiteCustomFields {...props} />
  </Page>
);
